import Link from '@components/ui-old/link';
import Image from "next/image";
import Text from '@components/ui-old/text';
import { useTranslation } from 'next-i18next';
import cn from 'classnames';
import { getPublicBaseUrl } from '@utils/getPublicBaseUrl';
interface Props {
  imgWidth?: number | string;
  imgHeight?: number | string;
  contactClassName?: string;
  variant?: 'default' | 'modern' | 'trendy';
  collection: {
    image: string;
    text: string;
    title: string;
    url: string;
  };
}
const CollectionCard: React.FC<Props> = ({
  collection,
  imgWidth = 580,
  imgHeight = 580,
  contactClassName = '',
  variant = 'default'
}) => {
  const {
    image,
    text,
    title,
    url
  } = collection;
  const {
    t
  } = useTranslation('common');
  return <Link href={url} className={cn('group text-center flex flex-col sm:last:hidden lg:last:flex border sm:border-0 border-neutral-300 dark:border-neutral-800 overflow-hidden rounded-md pb-4 sm:pb-0', {
    'justify-between sm:even:flex-col-reverse': variant === 'default',
    '!pb-0': variant === 'trendy'
  })} data-sentry-element="Link" data-sentry-component="CollectionCard" data-sentry-source-file="collection-card.tsx">
      <div className='flex mx-auto flex-col relative'>
        <div className='flex'>
          <Image src={image ? `${getPublicBaseUrl()}${image}` : '/assets/placeholder/collection.svg'} alt={t('title') || t('text-card-thumbnail')} width={Number(imgWidth)} height={Number(imgHeight)} className="bg-gray-300 object-cover sm:rounded-md transition duration-200 ease-in-out group-hover:opacity-90" style={{
          maxWidth: "100%",
          height: "auto"
        }} data-sentry-element="Image" data-sentry-source-file="collection-card.tsx" />
        </div>
        <div className={cn('overflow-hidden absolute bottom-3.5 lg:bottom-5 ltr:right-3.5 rtl:left-3.5 ltr:lg:right-5 rtl:lg:left-5 p-2', {
        '!bottom-[-12px] !right-[-12px]': variant === 'trendy'
      })}>
          <span className={cn('inline-block text-[13px] md:text-sm leading-4 cursor-pointer transition ease-in-out duration-300 font-semibold text-center rounded-md bg-white dark:bg-zinc-950 text-heading dark:text-neutral-200 shadow-navigation py-3 lg:py-4 px-4 lg:px-6 hover:bg-heading hover:text-white hover:dark:text-neutral-200 transform lg:translate-y-full lg:opacity-0 lg:group-hover:opacity-100 lg:group-hover:translate-y-0', {
          'bg-heading text-[#fff] dark:text-neutral-200 hover:bg-white dark:bg-zinc-950 hover:text-heading hover:dark:text-neutral-200 lg:px-12 lg:py-6': variant === 'trendy'
        })}>
            {t('button-view-collection')}
          </span>
        </div>
      </div>
      {variant !== 'trendy' && <div className={contactClassName}>
          <Text variant='mediumHeading' className='mb-1.5 lg:mb-2.5 2xl:mb-3 3xl:mb-3.5 dark:text-neutral-200'>
            {t(`${title}`)}
          </Text>
          <p className='text-body dark:text-neutral-400 text-[13px] md:text-sm leading-6 md:leading-7 xl:px-10 3xl:px-20'>
            {t(`${text}`)}
          </p>
        </div>}
    </Link>;
};
export default CollectionCard;